// @angular
import { Component, OnInit, untracked, ChangeDetectionStrategy } from "@angular/core";
// Translate
import { TranslateModule, TranslateService } from "@ngx-translate/core";
// Project services
import { SessionDataService } from "../../../../services/shared/SessionDataService.service";
// Interfaces
import { TableDataColumn } from "../../../../modules/table-module/TableInterface.type";
import { InstallationData } from "../installation-interface";
// Components
import { MaterialPanelMenuComponent } from "../../../../modules/material-module/material-panel-menu/material-panel-menu.component";
import { TableControllerComponent } from "../../../../modules/table-module/table-controller/table-controller.component";
import { Router } from "@angular/router";

/** Displays past meter activations from session data and opens the activation screen. */
@Component({
  selector: "app-installation-historical",
  templateUrl: "./installation-historical.component.html",
  styleUrls: ["./installation-historical.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialPanelMenuComponent, TableControllerComponent, TranslateModule]
})
export class InstallationHistoricalComponent implements OnInit {
  /***************************************************************************/
  // ANCHOR Variables
  /***************************************************************************/

  newIcon: string = "fas fa-plus";
  newTitle: string = this.translate.instant("new-ip");

  tableData: InstallationData[];
  columns: TableDataColumn[] = [
    {
      title: "date",
      data: "dateParsed",
      search: "dateParsed",
      sort: "date",
      visible: true
    },
    {
      title: "serialNumber",
      data: "serialNumber",
      search: "serialNumber",
      sort: "serialNumber",
      visible: true
    },
    {
      title: "state",
      data: "state",
      search: "state",
      sort: "state",
      visible: true
    }
  ];

  /***************************************************************************/
  // ANCHOR Constructor
  /***************************************************************************/

  constructor(
    private readonly router: Router,
    private readonly SessionDataService: SessionDataService,
    private readonly translate: TranslateService
  ) {}

  /***************************************************************************/
  // ANCHOR Component initialization
  /***************************************************************************/

  ngOnInit(): void {
    this.tableData = untracked(() => this.SessionDataService.componentData()) ?? [];
  }

  /***************************************************************************/
  // ANCHOR Functions
  /***************************************************************************/

  newActivation(): void {
    this.router.navigate(["/instalador/activacion"]);
  }
}
